export const ERR_LOGIN = 'ERR_LOGGIN'
export const ERR_NETWORK = 'ERR_NETWORK'
